import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './auth.module'
import { init } from './init.module'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth, init
  }
})

export default store
